/**
 * Feature flags that can be toggled in site settings.
 *
 * When removing a flag, create a data migration using cleanUpFeatureFlagFromServerConfig.
 */

const featureFlags = [
  'enableAiCourseGeneration',
  'enableCompetencyImprovements',
  'enableFeedbackForCalendarEvents',
  'enableMoodleImporter',
  'enableNewAnalytics'
] as const;

export default featureFlags;
